import { useEffect, useState } from "react";
import { InstallPromptContext } from "./InstallPromptContext";
import { isIOS, isInStandaloneMode } from "./detectPlatform";

const STORAGE_KEY = "pwa-install-dismissed-at";

export default function InstallPromptProvider({ children }) {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallUI, setShowInstallUI] = useState(false);

  useEffect(() => {
    if (isInStandaloneMode()) return;

    const lastDismiss = localStorage.getItem(STORAGE_KEY);
    if (lastDismiss) {
      const diff = Date.now() - Number(lastDismiss);
      if (diff < 1000 * 60 * 60 * 24 * 15) {
        return;
      }
    }

    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowInstallUI(true);
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

    if (isIOS()) {
      setShowInstallUI(true);
    }

    return () => {
      window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    };
  }, []);

  const dismiss = () => {
    localStorage.setItem(STORAGE_KEY, Date.now().toString());
    setShowInstallUI(false);
  };

  return (
    <InstallPromptContext.Provider
      value={{
        deferredPrompt,
        setDeferredPrompt,
        showInstallUI,
        setShowInstallUI,
        dismiss,
      }}
    >
      {children}
    </InstallPromptContext.Provider>
  );
}
